function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M312.209 100.948C307.622 125.127 253.168 117.806 221.751 156.109C196.605 186.754 217.157 208.901 187.583 237.024C183.742 240.674 155.74 266.506 117.989 263.436C80.0826 260.35 59.3701 230.341 52.5925 220.512C28.2824 185.275 38.7748 148.737 41.8804 138.613C56.4978 90.9613 102.147 66.9926 114.461 60.7482C129.601 53.0713 187.046 26.7175 246.635 45.7758C276.692 55.3919 316.298 79.4398 312.219 100.946L312.209 100.948Z",
  fill: "url(#paint0_linear_18921_121452)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 185.956,
  y: 69.6406,
  width: 6,
  height: 10.3281,
  rx: 3,
  fill: "#FF9999"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M94.3891 128.265L95.1613 222.315C95.1976 227.241 99.2209 231.205 104.144 231.168C105.692 231.157 107.147 230.749 108.412 230.044C111.168 228.509 113.02 225.558 112.996 222.18L112.857 203.283L205.345 202.586L204.797 128.293L94.3891 128.265Z",
  stroke: "#D8D8D8",
  strokeWidth: 0.716536,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "2.15 2.15"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M99.6615 137.622L189.121 138.412C195.989 138.467 201.518 144.083 201.471 150.958L200.978 216.191L123.839 215.567L123.923 210.349C123.903 213.332 122.809 216.051 121.011 218.148C120.791 218.408 120.558 218.658 120.315 218.897C118.107 221.074 115.068 222.406 111.72 222.38C105.029 222.326 99.6374 216.852 99.683 210.153L100.116 146.616C100.15 141.688 100.114 139.308 99.6615 137.622Z",
  fill: "#E4E4E4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M104.511 132.775L193.969 133.564C200.837 133.62 206.366 139.236 206.319 146.111L205.828 218.254L128.69 217.629L128.772 205.501C128.753 208.483 127.658 211.203 125.86 213.3C125.64 213.559 125.407 213.81 125.164 214.049C122.956 216.226 119.917 217.558 116.57 217.531C109.878 217.478 104.487 212.004 104.532 205.305L104.965 141.768C104.999 136.841 104.963 134.461 104.511 132.775Z",
  fill: "#C4C4C4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M126.823 73.9837L125.929 205.507C125.883 212.205 120.419 217.592 113.726 217.537L224.107 218.433C230.747 218.487 236.171 213.139 236.216 206.492L237.11 74.878L126.822 73.9829L126.823 73.9837Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M222.648 75.0656L190.466 74.5859L190.544 117.645C190.545 118.488 191.526 118.951 192.178 118.417L206.396 106.775C206.765 106.473 207.295 106.474 207.664 106.776L221.893 118.429C222.545 118.963 223.524 118.502 223.526 117.659L223.634 76.0686C223.636 75.5209 223.196 75.0738 222.648 75.0656Z",
  fill: "#EDEDED"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M224.129 69.8779L191.956 69.6387L192.032 115.389C192.034 116.232 193.014 116.696 193.667 116.162L207.884 104.52C208.253 104.218 208.783 104.218 209.152 104.52L223.38 116.174C224.033 116.708 225.012 116.246 225.014 115.403L225.122 70.8808C225.124 70.3303 224.68 69.882 224.129 69.8779Z",
  fill: "#FFE8E8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M178.511 123.196L143.449 123.184C141.907 123.172 140.655 121.9 140.666 120.357L140.666 120.234C140.676 118.691 141.946 117.439 143.487 117.451L178.55 117.463C180.091 117.475 181.343 118.748 181.333 120.291L181.333 120.414C181.323 121.957 180.053 123.208 178.511 123.196Z",
  fill: "#E4E4E4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M178.511 102.843L143.449 102.831C141.907 102.819 140.655 101.546 140.666 100.003L140.666 99.8801C140.676 98.3372 141.946 97.0858 143.487 97.098L178.55 97.1097C180.091 97.1219 181.343 98.3943 181.333 99.9372L181.333 100.061C181.323 101.603 180.053 102.855 178.511 102.843Z",
  fill: "#E4E4E4"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M143.338 137.107L220.34 137.663C221.887 137.676 223.134 138.937 223.123 140.479L223.122 140.602C223.112 142.143 221.848 143.384 220.301 143.372L143.299 142.816C141.752 142.803 140.505 141.542 140.516 140L140.516 139.877C140.527 138.336 141.791 137.095 143.338 137.107Z",
  fill: "#E4E4E4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M143.337 156.533L220.339 157.089C221.886 157.102 223.133 158.363 223.122 159.905L223.121 160.027C223.111 161.569 221.847 162.81 220.3 162.798L143.298 162.241C141.751 162.229 140.504 160.967 140.515 159.426L140.516 159.303C140.526 157.761 141.79 156.52 143.337 156.533Z",
  fill: "#E4E4E4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M143.335 177.183L220.337 177.739C221.884 177.752 223.131 179.013 223.12 180.555L223.119 180.678C223.109 182.22 221.845 183.461 220.298 183.448L143.296 182.892C141.749 182.879 140.502 181.618 140.513 180.076L140.514 179.954C140.524 178.412 141.788 177.171 143.335 177.183Z",
  fill: "#E4E4E4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M143.335 199.871L220.337 200.427C221.884 200.44 223.131 201.701 223.12 203.243L223.119 203.365C223.109 204.907 221.845 206.148 220.298 206.135L143.296 205.579C141.749 205.567 140.502 204.305 140.513 202.763L140.514 202.641C140.524 201.099 141.788 199.858 143.335 199.871Z",
  fill: "#E4E4E4"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M176.076 33.9295C179.74 32.949 181.913 29.1806 180.929 25.5126C179.945 21.8446 176.176 19.666 172.512 20.6465C168.848 21.627 166.675 25.3954 167.659 29.0634C168.643 32.7314 172.412 34.91 176.076 33.9295Z",
  fill: "#80EEF9"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M76.1292 149.653C75.9803 146.542 73.34 144.138 70.2319 144.284C67.1239 144.429 64.7251 147.069 64.8741 150.18C65.023 153.291 67.6634 155.695 70.7714 155.549C73.8794 155.404 76.2782 152.764 76.1292 149.653Z",
  fill: "#81E8D3"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M286.892 177.947C290.556 176.967 292.729 173.198 291.744 169.53C290.76 165.862 286.992 163.684 283.327 164.664C279.663 165.645 277.49 169.413 278.475 173.081C279.459 176.749 283.227 178.928 286.892 177.947Z",
  fill: "#80EEF9"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M216.025 83.4956C216.542 82.9797 216.542 82.1431 216.025 81.6272C215.509 81.1112 214.672 81.1112 214.155 81.6272L208.546 87.2326L202.936 81.6274C202.42 81.1115 201.583 81.1115 201.066 81.6274C200.55 82.1434 200.55 82.9799 201.066 83.4959L206.676 89.1011L201.066 94.7065C200.55 95.2224 200.55 96.059 201.066 96.5749C201.583 97.0909 202.42 97.0909 202.936 96.5749L208.546 90.9695L214.156 96.5749C214.672 97.0909 215.509 97.0909 216.026 96.5749C216.542 96.0589 216.542 95.2224 216.026 94.7065L210.416 89.101L216.025 83.4956Z",
  fill: "#DA1E21"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M191.956 72.6406C191.956 70.9838 190.613 69.6406 188.956 69.6406H191.956V72.6406Z",
  fill: "#FFE8E8"
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18921_121452",
  x1: 58.1122,
  y1: 176.812,
  x2: 299.81,
  y2: 223.684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA",
  stopOpacity: 0.44
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})));

function SvgAideNolicense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 354,
    height: 284,
    viewBox: "0 0 354 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAideNolicense);
export default __webpack_public_path__ + "static/media/aide-nolicense.1ea4029828c4478d7f1f8f15c1bebcae.svg";
export { ForwardRef as ReactComponent };